import { v4 as uuidv4 } from "uuid";
export class TeamSaveModel {
    constructor() {
        this.teamId = uuidv4();
        this.createdBy = uuidv4();
    }
}
export default class addTeam extends TeamSaveModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
